import { IoClose } from "react-icons/io5";

import { Button } from "@/components/atoms/Button";
import { TextInput } from "@/components/atoms/TextInput";

import { InputContainer } from "./styles";

interface SearchBarProps {
  searchText: string;
  onChange: (value: string) => void;
  onClear: () => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({ searchText, onChange, onClear }) => {
  return (
    <InputContainer>
      <TextInput
        type="text"
        placeholder="Search"
        aria-label="Search Input"
        value={searchText}
        onChange={(e) => onChange(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
      />
      <Button type="button" onClick={onClear}>
        <IoClose />
      </Button>
    </InputContainer>
  );
};
